import { getClients as rpcClients } from "@agrigate/reporting-api/lib/clients";
import type { Clients } from "@agrigate/rpc-clients";
import { getClients } from "@agrigate/rpc-clients";
import type { RPCMeta } from "@agrigate/shared/lib/rpc/clients";
import { isAuthFailure } from "@agrigate/shared/lib/utils/auth";
import { getRPC } from "@agrigate/shared-web-ui/lib/utils/rpc";
import { getDefaultStore } from "jotai";
import { set } from "lodash";
import { sessionAtom } from "../stores/session";
import { getTrackingId } from "./posthog";

console.log(`Using API_BASE=${API_BASE} for service registrations`);

export const getHeaders = async () => {
    const sessionState = getDefaultStore().get(sessionAtom);
    const mTrackingId = await getTrackingId();
    const headers: Record<string, string> = {};
    if (sessionState?.token) {
        headers.Authorization = `Bearer ${sessionState.token}`;
    } else if (EMAIL_HEADER) {
        if (location.host.match(/^localhost:/)) {
            headers["X-Token-User-Email"] = EMAIL_HEADER;
        } else {
            console.warn(
                "EMAIL_HEADER will be ignored when domain is not localhost",
            );
        }
    }
    headers.agmtrackingid = mTrackingId;
    return headers;
};

export const handleError = (
    method: string,
    params: unknown[],
    meta: RPCMeta | undefined,
    error: unknown,
) => {
    if (isAuthFailure(error)) {
        console.log("Handling auth failure", error, { method, params, meta });
        getDefaultStore().set(sessionAtom, null);
        location.href = `${LOGIN_URL}?redirect_url=${location.origin}`;
    }
};

const rpc: Clients = getClients(
    {
        backend: {
            url: API_BASE,
            getHeaders,
        },
        gateway: {
            url: API_GW_BASE,
            getHeaders,
        },
    },
    {
        onError: handleError,
    },
);

getRPC.override(() => () => rpc);

const useLocalRepAPI = process.env.USE_BACKEND_REP_API;

export const reportingRPC = rpcClients(
    {
        url: useLocalRepAPI ? API_BASE : API_GW_BASE,
        getHeaders,
    },
    useLocalRepAPI ? "backend" : "gateway",
    {
        onError: handleError,
    },
);

export default rpc;

// Exposed for debugging
set(window, `debugRPC${Math.round(Math.random() * 100)}`, rpc);
set(
    window,
    `getDebugRPC${Math.round(Math.random() * 100)}`,
    (token: string) => {
        const getHeaders = () => ({ Authorization: `Bearer ${token}` });
        return getClients({
            backend: {
                url: API_BASE,
                getHeaders,
            },
            gateway: {
                url: API_GW_BASE,
                getHeaders,
            },
        });
    },
);
